export const mutationTypes = {
  ADD_ERROR: 'ADD_ERROR',
  REMOVE_ERROR: 'REMOVE_ERROR',
  RESET_STATE: 'RESET_STATE',
  SET_TITLE: 'SET_TITLE',
  SET_SUBTITLE: 'SET_SUBTITLE',
  SET_DIRTY: 'SET_DIRTY',
  SET_COLUMN_HEADER_METADATA: 'SET_COLUMN_HEADER_METADATA',
  SAVING_PENDING: 'SAVING_PENDING',
  SAVING_SUCCESS: 'SAVING_SUCCESS',
  SAVING_FAILURE: 'SAVING_FAILURE',
  SET_TOP_ROW: 'SET_TOP_ROW',
  SET_COLUMNS: 'SET_COLUMNS',
  SET_SELECTED_RANGE: 'SET_SELECTED_RANGE',
  SET_SHOWING_UNSAVED_DIALOG: 'SET_SHOWING_UNSAVED_DIALOG',
  CLEAR_CELL_PENDING: 'CLEAR_CELL_PENDING',
  CLEAR_CELL_SUCCESS: 'CLEAR_CELL_SUCCESS',
  CLEAR_CELL_FAILURE: 'CLEAR_CELL_FAILURE',
  CLEAR_CELLS_PENDING: 'CLEAR_CELLS_PENDING',
  CLEAR_CELLS_SUCCESS: 'CLEAR_CELLS_SUCCESS',
  CLEAR_CELLS_FAILURE: 'CLEAR_CELLS_FAILURE',
  INSERTING_PENDING: 'INSERTING_PENDING',
  INSERTING_SUCCESS: 'INSERTING_SUCCESS',
  INSERTING_FAILURE: 'INSERTING_FAILURE',
  EDIT_CELL_PENDING: 'EDIT_CELL_PENDING',
  EDIT_CELL_SUCCESS: 'EDIT_CELL_SUCCESS',
  EDIT_CELL_FAILURE: 'EDIT_CELL_FAILURE',
  LOAD_REPORT_SUCCESS: 'LOAD_REPORT_SUCCESS',
  LOAD_REPORT_FAILURE: 'LOAD_REPORT_FAILURE',
  LOAD_REPORT_PENDING: 'LOAD_REPORT_PENDING',
  LOADING_FINISHED: 'LOADING_FINISHED',
  REFRESH_METADATA_PENDING: 'REFRESH_METADATA_PENDING',
  REFRESH_METADATA_SUCCESS: 'REFRESH_METADATA_SUCCESS',
  REFRESH_METADATA_FAILURE: 'REFRESH_METADATA_FAILURE',
  REFRESH_SUCCESS: 'REFRESH_SUCCESS',
  REFRESH_FAILURE: 'REFRESH_FAILURE',
  REFRESH_PENDING: 'REFRESH_PENDING',
  SET_READ_ONLY_MODE: 'SET_READ_ONLY_MODE',
  SWITCH_TO_READ_ONLY_MODE_PENDING: 'SWITCH_TO_READ_ONLY_MODE_PENDING',
  SWITCH_TO_READ_ONLY_MODE_SUCCESS: 'SWITCH_TO_READ_ONLY_MODE_SUCCESS',
  SWITCH_TO_READ_ONLY_MODE_FAILURE: 'SWITCH_TO_READ_ONLY_MODE_FAILURE'
}

export default {
  mutationTypes
}
